<template>
  <div class="row">
    <div class="col">
      <task-item
          v-for="goal in goals"
          :task="goal"
          :key="`goal-${goal.id}`"
          :isPersonal="true"
          :labelOptions="labelOptions"
          :type="'goals'"
          @taskUpdated="updateList"
          @taskDeleted="deleteFromList"
          @saveLabel="saveLabel"
          @deleteLabel="deleteLabel"
      ></task-item>
    </div>
  </div>
</template>

<script>
import Task from '../Task';

export default {
  name: 'GoalList',

  props: ['yourGoals'],

  data () {
    return {
      taskService: Task,
      goals: this.yourGoals ?? [],
    };
  },

  computed: {
    labelOptions () {
      return this.$store.state.labelOptions;
    },
  },

  methods: {
    async fetchGoals () {
      const data = await this.taskService.fetchUserGoals();
      this.goals = data.map(item => {
        item.title = item.name;

        return item;
      });

      this.$emit('storeTasksLocally', {
        key: 'yourGoals',
        tasks: this.goals,
      });
    },

    updateList (updatedGoal) {
      this.goals = this.goals.map(goal => {
        if (goal.id === updatedGoal.id) {
          Object.keys(updatedGoal).forEach(key => {
            goal[key] = updatedGoal[key];
          });
        }

        goal = {
          ...goal,
        };

        return goal;
      });

      this.$emit('storeTasksLocally', {
        key: 'yourGoals',
        tasks: this.goals,
      });
    },

    deleteFromList (deletedGoal) {
      this.goals = this.goals.filter(goal => {
        return goal.id !== deletedGoal.id;
      });

      this.$emit('storeTasksLocally', {
        key: 'yourGoals',
        tasks: this.goals,
      });
    },

    async saveLabel (data) {
      const { key, val } = data;

      if (key) {
        this.$store.state.labelOptions = this.labelOptions.map((value, labelKey) => {
          if (labelKey === key) {
            return {
              id: labelKey,
              name: val,
            };
          }

          return value;
        });
      } else {
        this.$store.state.labelOptions.push({
          id: this.labelOptions.length,
          name: val,
        });
      }
    },

    deleteLabel (labelKey) {
      const newLabels = this.labelOptions.filter((value, key) => {
        return key !== labelKey;
      });

      this.$store.state.labelOptions = newLabels.map((value, key) => {
        return {
          id: key,
          name: value.name,
        };
      });
    },
  },

  mounted () {
    if (!this.yourGoals) {
      this.fetchGoals();
    }
  }
};
</script>

<style scoped>

</style>
